module.exports = __webpack_public_path__ + "img/ID.254c28d7.png";